import { get, post, patch, httpDelete, download} from '../axiosReq'

export const userinfo_api = parmas => get("/qeda/user/userinfo/",parmas)
export const changePassword_api = parmas => patch("/qeda/user/change-password/",parmas)
export const getFileData_api = params => get("../../../static/cell.json",params)

//新Api
export const getUserInfo_api = params =>get('qeda/user/user_info/',params)